import FleetCoachTaskApi from "../../services/api/FleetCoachTaskV2";
import { setLoader, setStatus } from "./User";
import ActionTypes from "./ActionTypes";
import Errors from "../../constants/Errors.json";

function handleError(err) {
  console.log("error in fleet coach task actions :", err);
}

export const setTaskList = (payload) => {
  return {
    type: ActionTypes.SET_FCTASK_LIST,
    payload,
  };
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FILTERS_FCTASK,
    payload,
  };
};

const createTaskPayload = (payload) => {
  const {
    start_date,
    end_date,
    task_type,
    task_heading,
    description,
    csv_file,
    audio_file,
  } = payload;

  return {
    start_date: new Date(start_date),
    end_date: new Date(end_date),
    task_type,
    task_heading,
    description,
    csv_file,
    audio_file,
  };
};

const updateTaskPayload = (payload) => {
  const {
    start_date,
    end_date,
    task_type,
    task_heading,
    description,
    task_id,
    csv_file,
    audio_file,
  } = payload;

  return {
    start_date: new Date(start_date),
    end_date: new Date(end_date),
    task_type,
    task_heading,
    description,
    csv_file,
    audio_file,
    task_id,
  };
};

export const uploadCampaignAudio = () => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await FleetCoachTaskApi.uploadCampaignAudio();
    dispatch(setLoader(false));
    if (response) {
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.FILE_UPLOAD_FAILED,
      })
    );
    handleError(err);
  }
};

export const driverSelectionCSVUpload = () => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await FleetCoachTaskApi.driverSelectionCSVUpload();
    dispatch(setLoader(false));
    if (response) {
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.FILE_UPLOAD_FAILED,
      })
    );
    handleError(err);
  }
};

export const fetchTaskList =
  (
    filters = {},
    pageRequest = {
      page: 1,
      page_size: 10,
    }
  ) =>
  async (dispatch) => {
    try {
      const body = {
        page_request: pageRequest,
        ...filters,
      };
      dispatch(setLoader(true));
      const response = await FleetCoachTaskApi.fetchTaskList(body);
      dispatch(setLoader(false));
      if (response) {
        dispatch(setTaskList(response));
        dispatch(setActiveFilters(filters));
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.NOT_FOUND,
        })
      );
      handleError(err);
    }
  };

export const createFleetCoachTask = (payload) => async (dispatch) => {
  const requestPayload = createTaskPayload(payload);
  try {
    dispatch(setLoader(true));
    let response = await FleetCoachTaskApi.createFleetCoachTask(requestPayload);
    dispatch(setLoader(false));
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const updateFleetCoachTask = (payload) => async (dispatch) => {
  const requestPayload = updateTaskPayload(payload);
  try {
    dispatch(setLoader(true));
    let response = await FleetCoachTaskApi.updateFleetCoachTask(requestPayload);
    dispatch(setLoader(false));
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const deleteFleetCoachTask = (payload) => async (dispatch) => {
  const requestPayload = payload;
  try {
    dispatch(setLoader(true));
    let response = await FleetCoachTaskApi.deleteFleetCoachTask(requestPayload);
    dispatch(setLoader(false));
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
